import type {Comment as CommentType} from "~/repository/types"
import Model from "~/repository/models/Model";
import Author from "~/repository/models/Author";
import dayjs from "dayjs";
import type {Dayjs} from "dayjs";

export default class Comment extends Model<CommentType>() implements CommentType {
    id: number;
    parent_id: number
    lvl: number
    message: string
    created_at: Dayjs
    user: Author
    likes_count: number | undefined
    children: Array<CommentType>
    children_count: number
    is_liked: boolean

    constructor(data: CommentType) {
        super()
        this.id = data.id
        this.created_at = dayjs(data.created_at)
        this.parent_id = data.parent_id
        this.lvl = data.lvl
        this.message = data.message
        this.user = new Author(data.user)
        this.likes_count = data.likes_count
        this.children = data.children ? data.children.map(c => new Comment(c)) : []
        this.children_count = data.children_count
        this.is_liked = data.is_liked
    }
}
